import "./WorkCardStyles.css";
import React, { useState, useEffect } from "react";
import WorkCardData from "../WorkCardData/WorkCardData.jsx";

const WorkCard = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="projects-section">
      <div className={`pinterest-grid ${isVisible ? 'visible' : ''}`}>
        {WorkCardData.map((project, index) => (
          <div
            key={index}
            className={`project-card ${project.height || 'medium'} ${project.featured ? 'featured' : ''} ${project.hero ? 'hero' : ''}`}
            style={{
              animationDelay: `${index * 0.15}s`
            }}
          >
            <div className="card-inner">
              {/* Project Image */}
              <div className="image-container">
                {project.imgsrc ? (
                  <img 
                    className="project-image" 
                    src={project.imgsrc} 
                    alt={project.title}
                  />
                ) : (
                  <div className="descriptive-card-image">
                    <div className="descriptive-icon">🔒</div>
                    <div className="descriptive-text">Private Projects</div>
                  </div>
                )}
                <div className="image-overlay">
                  <div className="overlay-buttons">
                    <a 
                      href={project.view} 
                      target="_blank"
                      rel="noopener noreferrer" 
                      className="overlay-btn primary-btn"
                    >
                      <span>Demo</span>
                      <span>→</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Project Content */}
              <div className="card-content">
                {project.role && <span className="project-role-badge">{project.role}</span>}
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.text}</p>
                
                {/* Technologies */}
                {project.technologies.length > 0 && (
                  <div className="tech-stack">
                    {project.technologies.map((tech, techIndex) => (
                      <div key={techIndex} className="tech-tag">
                        {tech}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WorkCard;
